
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8.25","cy":"8.152","r":"7.5","stroke":"#56BFC7"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.979 6.901a.5.5 0 00-.707-.707L7.71 9.756 5.645 7.69a.5.5 0 00-.708.707l2.388 2.388a.5.5 0 00.049.042.5.5 0 00.692-.014L11.979 6.9z","fill":"#56BFC7"}})])
          )
        }
      }
    